import { jsxs as i, jsx as o, Fragment as C } from "react/jsx-runtime";
import { useState as b } from "react";
import y from "./useModal.js";
import c from "./Button.js";
import g from "./FieldWrapper.js";
import I from "./Form.js";
import M from "./InputWrapper.js";
import N from "./Label.js";
import W from "./Markdown.js";
import { M as d } from "./chunks/index-B8d-pCoN.js";
import k from "./TextInput.js";
const x = ({
  button: t = "Confirm",
  className: l,
  description: e = "This action cannot be undone!",
  dismissableId: r,
  modal: n,
  onConfirm: s,
  title: m = "Are you sure you want to do this?",
  writtenConfirmation: a
}) => {
  const [f, p] = b(!!a), u = (h) => {
    p(h !== a);
  };
  return /* @__PURE__ */ i(d, { className: l, dismissableId: r, modal: n, children: [
    /* @__PURE__ */ o(d.Heading, { children: m }),
    /* @__PURE__ */ o(W, { className: "py-2", children: e }),
    a && /* @__PURE__ */ i(I, { className: "gap-4 items-start pb-2", onSubmit: () => null, children: [
      /* @__PURE__ */ i("p", { children: [
        "Please type",
        " ",
        /* @__PURE__ */ o("strong", { className: "font-semibold", children: a }),
        " to confirm"
      ] }),
      /* @__PURE__ */ i(g, { className: "w-full", children: [
        /* @__PURE__ */ o(N, { className: "sr-only", isRequired: !0, children: "Written confirmation" }),
        /* @__PURE__ */ o(
          M,
          {
            input: k,
            name: "writtenConfirmation",
            onChange: u
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ i("div", { className: "flex gap-3 justify-end", children: [
      /* @__PURE__ */ o(c, { isGhost: !0, level: "secondary", onClick: n.close, children: "Cancel" }),
      /* @__PURE__ */ o(
        c,
        {
          disabled: f,
          onClick: () => {
            n.close(), s();
          },
          children: t
        }
      )
    ] })
  ] });
}, H = (t) => ({ modal: e, onClick: r, ...n }) => {
  const s = y();
  return e ? /* @__PURE__ */ i(C, { children: [
    /* @__PURE__ */ o(t, { ...n, onClick: () => {
      document.cookie.includes(e.dismissableId) ? r() : s.open();
    } }),
    /* @__PURE__ */ o(
      x,
      {
        dismissableId: e.dismissableId,
        modal: s,
        onConfirm: r,
        ...e
      }
    )
  ] }) : /* @__PURE__ */ o(t, { onClick: r, ...n });
};
export {
  x as ConfirmationModal,
  H as default
};
